import type { LegacyTouchState } from '../services/LegacyEnterpriseServer/types'

/** 截止时间是服务端的排他边界；界面显示北京时间最后可处理日。 */
export function legacyDeadlineLabel(deadline?: string): string {
  if (!deadline || !/(Z|[+-]\d{2}:\d{2})$/.test(deadline)) return ''
  const time = Date.parse(deadline)
  if (!Number.isFinite(time)) return ''
  const d = new Date(time - 1 + 8 * 3600000)
  return `${d.getUTCMonth() + 1}月${d.getUTCDate()}日`
}

export function legacyBanner(state: LegacyTouchState | null): string {
  if (!state) return ''
  if (state.banner === 'PROCESSING' && state.status === 'MIGRATING') return 'PROCESSING'
  if (!legacyDeadlineLabel(state.deadline)) return ''
  if (state.banner === 'A' && state.owner === true && state.canDecide === true && state.daysRemaining > 0) return 'A'
  if (state.banner === 'B' && state.owner === false && state.daysRemaining > 0) return 'B'
  if (state.banner === 'C' && state.daysRemaining > 0) return 'C'
  if (state.banner === 'D' && state.owner === true && state.status === 'COMPLETED' && state.regionMode === 'CROSS_REGION') return 'D'
  return ''
}

/** 每个登录身份独立计数；迟到响应不得污染切换后的企业，访问确认每次挂载最多一次。 */
export function createLegacyTouchLoader(api: {
  state: () => Promise<{ code: string; data?: LegacyTouchState }>,
  visit: () => Promise<{ code: string; data?: LegacyTouchState }>,
}, apply: (state: LegacyTouchState | null) => void, prompt: (state: LegacyTouchState) => void) {
  let identity = '', revision = 0, loading = false, visited = false
  return {
    reset(next: string) {
      if (next === identity) return
      identity = next; revision++; loading = false; visited = false; apply(null)
    },
    async refresh() {
      if (!identity || loading) return
      const current = revision
      loading = true
      try {
        const response = await api.state()
        if (revision !== current) return
        const state = response.code === '1' && response.data ? response.data : null
        apply(state)
        if (!visited && state?.owner === true && (state.canDecide === true || state.status === 'DEFAULTED')) {
          visited = true
          const result = await api.visit()
          if (revision !== current) return
          if (result.code === '1' && result.data) {
            apply(result.data)
            if (['BIND_EMAIL', 'SELECT_REGION', 'DEFAULT_INTERNATIONAL'].includes(result.data.prompt || '')) prompt(result.data)
          }
        }
      } catch {
        if (revision === current) apply(null)
      } finally {
        if (revision === current) loading = false
      }
    },
    dispose() { identity = ''; revision++; loading = false; apply(null) },
  }
}
